import { useContext, useEffect, useRef, useState } from 'react';
import { ReactReduxContext, useDispatch } from 'react-redux';
import { useWizard } from 'react-use-wizard';
import { ADD_STEP, REMOVE_STEP, RESET_STEPS } from '../constants/ActionTypes';
import { motion } from "framer-motion";
import backarrowIcon from '../assets/backarrow.svg';
import { Link, useLocation } from 'react-router-dom';

function ButtonsStep({ stepElements, stepTitle, pQuestion = false, pAnswer = false, backButton = true, nextButton = false }) {
    const { previousStep, goToStep, isFirstStep, activeStep } = useWizard();
    const [subStepsActive, setSubStepsActive] = useState(false);
    const dispatch = useDispatch();
    const { store } = useContext(ReactReduxContext);
    const location = useLocation();
    const myRef = useRef(null);
    const [parentQuestion, setParentQuestion] = useState(false);
    const [parentAnswer, setParentAnswer] = useState(false);
    const [activeButtons, setActiveButtons] = useState({});

    useEffect(() => {
        if (location.pathname === '/') {
            dispatch({
                type: RESET_STEPS,
            });

            backToTop();

            goToStep(0);
        }
    }, [location]);

    useEffect(() => {
        if (subStepsActive) executeScroll();
    });

    const container = {
        hidden: { opacity: 1, scale: 0 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                delayChildren: 0.3,
                staggerChildren: 0.2
            }
        }
    };

    const item = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1
        }
    };

    const backToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const executeScroll = () => myRef.current.scrollIntoView()

    const goBack = () => {
        var hasStepKW = false;

        store.getState().steps.forEach(element => {
            if (element.nStep === 4) hasStepKW = true;
        });

        if (activeStep > 4 && !hasStepKW) {
            dispatch({
                type: REMOVE_STEP,
                step: activeStep - 2,
            });
        } else {
            dispatch({
                type: REMOVE_STEP,
                step: activeStep - 1,
            });
        }

        backToTop();

        // if (typeof window.dataLayer !== "undefined") window.dataLayer.push({
        //     event: `calcolatore_pag_${activeStep - 1}`
        // });

        previousStep();
    };

    const goTo = (value, textAnswer, index) => {
        var step = { nStep: activeStep, value: value, question: stepTitle, answer: textAnswer };
        if (pQuestion && pAnswer) step["parent"] = { question: pQuestion, answer: pAnswer };

        dispatch({
            type: ADD_STEP,
            step: step,
        });

        backToTop();

        // if (typeof window.dataLayer !== "undefined") window.dataLayer.push({
        //     event: `calcolatore_pag_${index}`
        // });

        goToStep(index);
    };

    const GoBackButton = () => {
        return (
            <button
                onClick={
                    (e) => { goBack() }
                }
                className="btn border-0 d-flex align-items-center gap-3"
            >
                <img src={backarrowIcon} className='img-fluid' />
                Back
            </button>
        );
    }

    const toggle = id => {
        setActiveButtons(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    }

    const Button = ({ element }) => {
        return (
            <>
                <motion.button
                    variants={item}
                    onClick={
                        (e) => {
                            if (element.noNextStep) {
                                var steps = store.getState().steps;
                                // Check if step already exists
                                var stepExists = false;
                                steps.forEach(step => {
                                    if (step.nStep === activeStep) stepExists = step;
                                });
                                if (stepExists) {
                                    dispatch({
                                        type: REMOVE_STEP,
                                        step: activeStep,
                                    });
                                }

                                toggle(e.currentTarget.value);

                                var step = { nStep: activeStep, value: [e.currentTarget.value], question: stepTitle, answer: [e.currentTarget.attributes['data-answer'].value] };
                                if (stepExists) {
                                    // If exists and is not in array, add to array
                                    if (!stepExists.value.includes(e.currentTarget.value)) {
                                        step = {
                                            nStep: activeStep,
                                            value: [...stepExists.value, e.currentTarget.value],
                                            question: stepTitle,
                                            answer: [...stepExists.answer, e.currentTarget.attributes['data-answer'].value]
                                        };
                                    } else {
                                        // If exists and is in array, remove from array
                                        var indexValue = stepExists.value.indexOf(e.currentTarget.value);
                                        var indexAnswer = stepExists.answer.indexOf(e.currentTarget.attributes['data-answer'].value);
                                        stepExists.value.splice(indexValue, 1);
                                        stepExists.answer.splice(indexAnswer, 1);
                                        step = {
                                            nStep: activeStep,
                                            value: [...stepExists.value],
                                            question: stepTitle,
                                            answer: [...stepExists.answer]
                                        };
                                    }
                                }

                                // If after all the array is empty, do not add the step
                                if (step.value.length === 0) return;

                                dispatch({
                                    type: ADD_STEP,
                                    step: step,
                                });
                            } else {
                                if (!element.subSteps) {
                                    if (element.nextStep) goTo(e.currentTarget.value, e.currentTarget.attributes['data-answer'].value, element.nextStep);
                                    else goTo(e.currentTarget.value, e.currentTarget.attributes['data-answer'].value, activeStep + 1);
                                } else {
                                    setParentQuestion(stepTitle);
                                    setParentAnswer(e.currentTarget.attributes['data-answer'].value);
                                    setSubStepsActive(true);
                                }
                            }
                        }
                    }
                    className={(activeButtons[element.value] ? "active" : "") + ' btn d-flex align-items-center justify-content-between step-button'}
                    value={element.value}
                    data-answer={element.text}
                    style={{ maxWidth: 250 + 'px' }}
                >
                    <div className="d-flex align-items-center w-100 flex-column gap-2">
                        {element.image ? (
                            <img src={element.image} className='img' style={{ marginBottom: 10 + 'px', maxWidth: 60 + "px", width: 100 + '%', maxHeight: 60 + 'px', height: "auto" }} />
                        ) : null}
                        {element.imageHover ? (
                            <img src={element.imageHover} className='img-hover' style={{ marginBottom: 10 + 'px', maxWidth: 60 + "px", width: 100 + '%', maxHeight: 60 + 'px', height: "auto" }} />
                        ) : null}
                        <p className='fw-500 mb-0' dangerouslySetInnerHTML={{ __html: element.text }}></p>
                    </div>
                </motion.button>
            </>
        )
    }

    return (
        <>
            <motion.div
                className="d-flex align-items-stretch justify-content-center gap-4 mb-4 flex-wrap"
                variants={container}
                initial="hidden"
                animate="visible"
            >
                {stepElements.map(element => {
                    return <>
                        {activeStep === 0 ? (
                            <Link to={'/ps'} className='text-decoration-none' style={{ maxWidth: 215 + 'px', width: 100 + '%' }}>
                                <Button element={element} />
                            </Link>
                        ) : (
                            activeStep === 4 ?
                                <Link to={'/ps/result'} className='text-decoration-none' style={{ maxWidth: 215 + 'px', width: 100 + '%' }}>
                                    <Button element={element} />
                                </Link>
                                :
                                <Button element={element} />
                        )}
                    </>
                })}
                {stepElements.map(element => {
                    return <>
                        {element.subSteps ? (
                            <div ref={myRef} className={"w-100 collapse" + (subStepsActive ? " show" : "")}>
                                <h1 className='h2 fw-normal mb-5 mt-3 text-center'>{element.subSteps.title}</h1>
                                <ButtonsStep stepElements={element.subSteps.steps} stepTitle={element.subSteps.title} pQuestion={parentQuestion} pAnswer={parentAnswer} backButton={false} />
                            </div>
                        ) : null}
                    </>
                })}
            </motion.div>
            {!isFirstStep && backButton ? (
                <>
                    {activeStep === 1 ? (
                        <Link to={'/'} className='text-decoration-none mt-4'>
                            <GoBackButton />
                        </Link>
                    ) :
                        <GoBackButton />
                    }
                </>
            ) : null}
            {nextButton ? (
                <button
                    onClick={
                        (e) => {
                            goToStep(activeStep + 1);
                        }
                    }
                    className="btn btn-fiducia next-step mt-4"
                >
                    Next step
                </button>
            ) : null}
        </>
    );
}

export default ButtonsStep;